import React from 'react';
import { Row } from 'antd';
import { CommentOutlined } from '@ant-design/icons';
import { Option, Col } from './style';
import LinkOption from './LinkOption';

interface OptionsListProps {
  subscriptionOptions?: {
    name: string;
    option: string;
  }[];
  showOptions?: boolean;
  onSelect: React.ComponentProps<typeof LinkOption>['onClick'];
}

const OptionsList = function ({
  subscriptionOptions = [],
  showOptions = false,
  onSelect,
}: OptionsListProps) {
  if (!showOptions) return null;

  return (
    <Row justify="center" gutter={[8, 8]}>
      {subscriptionOptions.map(({ name, option }) => {
        const showContactAsLink = option === 'Transfer';
        return (
          <Col key={option} xs={showContactAsLink ? 24 : {}}>
            {!showContactAsLink
              ? (
                <Option
                  id={option}
                  name={name}
                  onClick={onSelect}
                  $highlighted={option === 'No'}
                  icon={option === 'No' && (
                    <CommentOutlined style={{ fontSize: '26px' }} />
                  )}
                />
              )
              : <LinkOption id={option} name={name} onClick={onSelect} />}
          </Col>
        );
      })}
    </Row>
  );
};

export default OptionsList;
